import React from 'react';
import {useUpdateFormMutation, Form} from 'api';
import ReactQuill from 'react-quill';
import useDebounce from 'hooks/useDebounce';
import Code from './Code';

interface Props {
  form: Form;
}

export default ({form}: Props) => {
  const ref = React.useRef(null);
  const [error, setError] = React.useState<string | null>(null);
  const [updateForm] = useUpdateFormMutation();

  const [bodyHtml, setBodyHtml] = React.useState(
    form.autoreplyMailBodyHtml || form.autoreplyMailBody || '',
  );
  const debouncedValue = useDebounce<string>(bodyHtml, 500);

  React.useEffect(() => {
    ref.current &&
      debouncedValue !== form.autoreplyMailBodyHtml &&
      updateForm({
        variables: {
          uuid: form.uuid,
          attributes: {
            autoreplyMailBodyHtml: debouncedValue,
            autoreplyMailBody: ref.current?.editor.getText(),
          },
        },
      });
  }, [form, debouncedValue, ref]);

  return (
    <div className="flex flex-col gap-12">
      <div className="flex flex-col gap-1 w-full">
        <label className="text-c-base font-bold">本文</label>
        <div className="relative">
          <div
            className={`
        relative
        [&_a]:text-c-primary
        [&_.ql-toolbar]:border-t-none
        [&_.ql-toolbar]:border-x-none
        [&_.ql-toolbar]:border-c-border
        [&_.ql-toolbar]:bg-white
        [&_.ql-toolbar]:rounded-t
        [&_.ql-container]:min-h-[100px]
        [&_.ql-container]:border-c-border
        [&_.ql-container]:bg-white
        [&_.ql-editor]:min-h-[100px]
        [&_.ql-editor]:rounded-b
        [&_.ql-editor]:${form.sendAutoreplyMail ? 'bg-white' : 'bg-c-bg'}
        [&_.ql-editor]:${
          form.sendAutoreplyMail ? 'text-c-base' : 'text-c-light'
        }
        [&_.ql-editor_a]:no-underline
      `}>
            <ReactQuill
              ref={ref}
              theme="snow"
              placeholder="本文を記入してください"
              modules={{
                toolbar: {
                  container: [['bold', 'italic', 'underline', 'link']],
                },
              }}
              value={bodyHtml}
              onChange={(value) =>
                setBodyHtml(
                  value === '<p><br></p>' || value === '\n' ? '' : value,
                )
              }
            />
          </div>
          <Code
            form={form}
            onClick={(value: string) => {
              if (ref.current?.editor.getSelection()) {
                ref.current?.editor.insertText(
                  ref.current?.editor.getSelection().index,
                  value,
                );
              }
            }}
            setError={setError}
          />
        </div>
        {form.sendAutoreplyMail &&
        ['', '\n', '<p><br></p>'].includes(bodyHtml) ? (
          <div className="text-red-500">本文が入力されていません。</div>
        ) : null}
        {error && <div className="text-red-500">{error}</div>}
      </div>
    </div>
  );
};
